import AppProvider from 'providers/app';
import AppRoutes from 'routes';
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BagelChatProvider } from 'features/bagel';
import BagelChatGate from 'features/bagel/chat/BagelChatGate';

function App() {
  // render routes
  return (
    <HelmetProvider>
      <AppProvider>
        <BagelChatProvider>
          <AppRoutes />
          {/* Global Bagel AI chat widget — rendered outside routes so it persists across navigation */}
          <BagelChatGate />
        </BagelChatProvider>
      </AppProvider>
    </HelmetProvider>
  );
}

export default App;
